<template>
    <div class="loading">
        <img src="/img/loading.gif" width="50">
        <h2>{{text}}</h2>
    </div>
</template>
<script>
export default{
    props: {
        text: {
            type: String,
            default: "Caricamento in corso..."
        }
    }
}
</script>
<style scoped>
.loading{
    padding: 10px;
    text-align: center;
}
</style>